
export const headerClass =
  "text-md text-center font-bold text-gray-700 dark:text-white";

export const cellClass =
  "text-sm text-right md:text-center font-bold text-navy-700 dark:text-white flex items-center justify-center flex justify-end";